// SalesStatisticsStore.ts
import { makeAutoObservable, runInAction } from "mobx";
import SalesStatisticsController, { SalesCategoryModel, SalesThemeDetailModel, SalesStatisticsParams } from "../controllers/SalesStatisticsController";

export default class SalesStatisticsStore {
  private _controller = new SalesStatisticsController(
    process.env.REACT_APP_STUDIO_API_HOST_URL ?? "",
    process.env.REACT_APP_STUDIO_API_KEY_ADMIN ?? ""
  );

  data: SalesCategoryModel[] = [];
  isLoading: boolean = false;

  detailData: SalesThemeDetailModel[] = [];
  isDetailLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public async fetchAsync(params: SalesStatisticsParams) {
    runInAction(() => {
      this.isLoading = true;
    });

    try {
      const data = await this._controller.getSalesThemesAsync(params);
      runInAction(() => {
        this.data = data;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public async fetchDetailAsync(params: SalesStatisticsParams) {
    runInAction(() => {
      this.isDetailLoading = true;
    });

    try {
      const detailData = await this._controller.getSalesThemesDetailAsync(params);
      runInAction(() => {
        this.detailData = detailData;
      });
    } finally {
      runInAction(() => {
        this.isDetailLoading = false;
      });
    }
  }
}
